import {
  ShoppingCart,
  Cable,
  Receipt,
  Handshake,
  AlertTriangle,
  MessageCircle,
} from 'lucide-react';

export const supportCategories = [
  {
    id: 'marketplace',
    name: 'Marketplace',
    icon: ShoppingCart,
    description: 'Pedidos, aprovisionamiento de licencias, catálogo y suscripciones del Cloud Marketplace.',
    examples: ['Estado de un pedido', 'Licencia no aprovisionada', 'Producto no visible en catálogo'],
  },
  {
    id: 'integraciones-vendors',
    name: 'Integraciones con Vendors',
    icon: Cable,
    description: 'Conectores API con Microsoft, AWS, Google, Adobe, Acronis y el resto de fabricantes.',
    examples: ['Error de sincronización API', 'Alta de un nuevo vendor', 'Credenciales de conector'],
  },
  {
    id: 'facturacion-pagos',
    name: 'Facturación y Pagos',
    icon: Receipt,
    description: 'Facturas, cobros recurrentes, conciliación y configuración de modelos de pricing.',
    examples: ['Factura incorrecta', 'Fallo en cobro recurrente', 'Cambio de plan o pricing'],
  },
  {
    id: 'apm-partner-manager',
    name: 'APM / Partner Manager',
    icon: Handshake,
    description: 'Gestión de mayoristas, contratos, certificaciones y el portal Partner Manager.',
    examples: ['Acceso a la beta', 'Carga de contratos', 'Certificaciones de equipo'],
  },
  {
    id: 'incidencias-tecnicas',
    name: 'Incidencias Técnicas',
    icon: AlertTriangle,
    description: 'Errores de plataforma, problemas de rendimiento, accesos y disponibilidad del servicio.',
    examples: ['Error al iniciar sesión', 'Plataforma lenta o caída', 'Error inesperado en un módulo'],
  },
  {
    id: 'solicitudes-generales',
    name: 'Solicitudes Generales',
    icon: MessageCircle,
    description: 'Dudas sobre cuentas, información comercial, documentación y cualquier otra consulta.',
    examples: ['Gestión de mi cuenta', 'Información de producto', 'Otras consultas'],
  },
];

export const supportPriorities = [
  { value: 'baja', label: 'Baja — Consulta sin urgencia' },
  { value: 'media', label: 'Media — Afecta parcialmente mi operación' },
  { value: 'alta', label: 'Alta — Afecta de forma importante mi operación' },
  { value: 'critica', label: 'Crítica — Servicio detenido' },
];

export const supportFaqs = [
  {
    question: '¿Cuál es el tiempo de respuesta del equipo de soporte?',
    answer:
      'Respondemos los tickets en menos de 24 horas hábiles. Las incidencias marcadas como críticas se atienden con prioridad y reciben primera respuesta en menos de 4 horas hábiles.',
  },
  {
    question: 'Una licencia del Marketplace no se aprovisionó, ¿qué hago?',
    answer:
      'La mayoría de licencias se aprovisionan automáticamente en minutos vía API. Si tras 30 minutos no está activa, crea un ticket en la categoría Marketplace indicando el número de pedido y el producto afectado.',
  },
  {
    question: '¿Cómo reporto un error en la sincronización con un vendor?',
    answer:
      'Crea un ticket en la categoría Integraciones con Vendors indicando el fabricante (Microsoft, AWS, Adobe, etc.), la operación que falló y la hora aproximada. Nuestro equipo revisa los logs del conector y te responde con el diagnóstico.',
  },
  {
    question: 'Detecté un error en una factura, ¿cómo lo corrijo?',
    answer:
      'Abre un ticket en Facturación y Pagos adjuntando el número de factura y la descripción de la discrepancia. Si procede, emitimos la nota de crédito y la factura rectificativa en el siguiente ciclo.',
  },
  {
    question: '¿Cómo accedo a la beta de Asisant Partner Manager?',
    answer:
      'Puedes solicitar acceso directamente en partnermanager.asisant.com o crear un ticket en la categoría APM / Partner Manager y el equipo habilitará tu cuenta.',
  },
  {
    question: '¿Puedo hacer seguimiento de mi ticket?',
    answer:
      'Sí. Al crear el ticket recibes un número de referencia (formato AST-XXXXXX). Guárdalo y menciónalo en cualquier comunicación con el equipo para agilizar el seguimiento.',
  },
];

export const supportChannels = [
  {
    type: 'email',
    title: 'Email de soporte',
    value: 'soporte@asisant.com',
    href: 'mailto:soporte@asisant.com',
    note: 'Respuesta en menos de 24h hábiles',
  },
  {
    type: 'email',
    title: 'Consultas comerciales',
    value: 'info@asisant.com',
    href: 'mailto:info@asisant.com',
    note: 'Demos, precios y partnership',
  },
  {
    type: 'schedule',
    title: 'Horario de atención',
    value: 'Lunes a Viernes · 9:00 – 18:00',
    note: 'Zona horaria CET / CLT según región',
  },
];
